import { createEffect, createEvent, createStore } from 'effector';
import { createFilterBag } from '@tools/factories';

export const defaultFilters = {
  created_at_from: '',
  created_at_to: '',
  statuses: [],
  isSupportActive: false,
  isTehzor: false,
  priorities: [],
  classes: [],
  types: [],
  payment: '',
  invoiceStatus: '',
  objects: [],
  houses: [],
  apartments: [],
  property: [],
  initiators: [],
  stuff_write_off_needed: '',
  assignees: [],
  rates: [],
  expired: '',
  isUnreadMessage: '',
  has_related: false,
};

export const {
  changedFilterVisibility,
  filtersSubmitted,
  $isFilterOpen,
  $filters,
  $isFiltersApply,
} = createFilterBag(defaultFilters);

export const $setFiltersCounter = createStore(0);
export const setFilters = createEvent();

export const fxSetLocaleStorage = createEffect<
  { key: string; data: string },
  void,
  Error
>().use(({ key, data }) => localStorage.setItem(key, data));
